// https://codepen.io/mihaeltomic/pen/PqxVaq
import React from "react"
import { css } from "@emotion/react"

const linkPopoverLayout = css`
  /* Popover styling */

  a {
    text-decoration: none;
    font-size: large;
  }

  position: relative;
  margin-top: 0.5rem;
  display: inline-block;
  line-height: initial;
  font-size: initial;
  z-index: 1000;

  .popover__content {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    transform: translate(0, 10px);
    background-color: #fcf7b4;
    padding: 1.5rem;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
    //width: auto;
    width: 100vw;
    max-width: 600px;
  }

  :hover .popover__content {
    z-index: 10;
    opacity: 1;
    visibility: visible;
  }
  .popover__message {
    text-align: center;
  }
  .footnote-backref {
    display: none;
  }
`

export default function LinkPopover(props) {
  return (
    <div className="popover__wrapper" css={linkPopoverLayout}>
      <a href="#">{String.fromCharCode(0x24d8)}</a>
      <div
        className="popover__position"
        css={css`
          display: flex;
          display: -webkit-flex;
          display: flex;
          -webkit-align-items: center;
          align-items: center;
          -webkit-justify-content: center;
          justify-content: center;
          position: fixed;
          left: 50vw;
          top: 50vh;
          bottom: -height;
        `}
      >
        <div className="popover__content">{props.note.props.children}</div>
      </div>
    </div>
  )
}
